export const lightBlueColor = "tAd";
export const lightGreenColor = "uAd";
export const lightYellowColor = "vAd";
export const lightOrangeColor = "wAd";
export const lightRedColor = "xAd";
export const lightPurpleColor = "yAd";
export const blueColor = "zAd";
export const greenColor = "AAd";
export const yellowColor = "BAd";
export const orangeColor = "CAd";
export const redColor = "DAd";
export const purpleColor = "EAd";
export const darkBlueColor = "FAd";
export const darkGreenColor = "GAd";
export const darkYellowColor = "HAd";
export const darkOrangeColor = "IAd";
export const darkRedColor = "JAd";
export const darkPurpleColor = "KAd";
export const darkerBlueColor = "LAd";
export const darkerGreenColor = "MAd";
export const darkerYellowColor = "NAd";
export const darkerOrangeColor = "OAd";
export const darkerRedColor = "PAd";
export const darkerPurpleColor = "QAd";
export const whiteColor = "RAd";
export const lightGrayColor = "SAd";
export const grayColor = "TAd";
export const darkGrayColor = "UAd";
export const darkerGrayColor = "VAd";
export const blackColor = "WAd";
export const cyanColor = "XAd";
export const magentaColor = "YAd";
export const lightCyanColor = "ZAd";
export const lightMagentaColor = "_Ad";
export const noColor = "$Ad";
export const moreColor = "aBd";
export default {lightBlueColor,lightGreenColor,lightYellowColor,lightOrangeColor,lightRedColor,lightPurpleColor,blueColor,greenColor,yellowColor,orangeColor,redColor,purpleColor,darkBlueColor,darkGreenColor,darkYellowColor,darkOrangeColor,darkRedColor,darkPurpleColor,darkerBlueColor,darkerGreenColor,darkerYellowColor,darkerOrangeColor,darkerRedColor,darkerPurpleColor,whiteColor,lightGrayColor,grayColor,darkGrayColor,darkerGrayColor,blackColor,cyanColor,magentaColor,lightCyanColor,lightMagentaColor,noColor,moreColor};